import { createContext, useContext } from "react";

import type { DatePickerContextValue } from "./DatePicker.types";

export function makeDatePickerContext({
  size = "md",
  layout = "default",
  disabled = false,
  arrow = true,
  locale = undefined,
  viewYear = new Date().getFullYear(),
  viewMonth = new Date().getMonth(),
  selected = null,
  range = false,
  selectedRange = [null, null],
  openEnd = null,
  openEnded = false,
  chooseOpenEnd = () => {},
  hoveredDay = null,
  setHoveredDay = () => {},
  min = null,
  max = null,
  weekStartsOn = 1,
  pointerOffsetRef = { current: 0 },
  selectDay = () => {},
  goToMonth = () => {},
  goToView = () => {},
}: Partial<DatePickerContextValue>): Required<DatePickerContextValue> {
  return {
    size,
    layout,
    disabled,
    arrow,
    locale,
    viewYear,
    viewMonth,
    selected,
    range,
    selectedRange,
    openEnd,
    openEnded,
    chooseOpenEnd,
    hoveredDay,
    setHoveredDay,
    min,
    max,
    weekStartsOn,
    pointerOffsetRef,
    selectDay,
    goToMonth,
    goToView,
  };
}

export const DatePickerContext = createContext<
  Required<DatePickerContextValue>
>(makeDatePickerContext({}));

export function useDatePickerContext() {
  return useContext(DatePickerContext);
}
